import { Button } from '@talentmesh/ui/components/button';
import { Popover, PopoverContent, PopoverTrigger } from '@talentmesh/ui/components/popover';
import { Share2Icon } from 'lucide-react';
import React from 'react';
import { isDesktop } from 'react-device-detect';
import ShareCard from '../Cards/ShareCard';
import ApplyButton from './ApplyButton';

interface ActionButtonsProps {
    jobAdTitle: string;
    onBoardUrl: string;
}

function ActionButtons({ jobAdTitle, onBoardUrl }: ActionButtonsProps): React.JSX.Element {
    return (
        <div className="flex flex-row gap-2">
            <ApplyButton onBoardUrl={onBoardUrl} />
            <Popover>
                <PopoverTrigger asChild>
                    <Button type="button" variant="outline" size="icon">
                        <Share2Icon />
                        <span className="sr-only">Share</span>
                    </Button>
                </PopoverTrigger>
                <PopoverContent align="end" className={isDesktop ? 'w-84' : 'w-full'}>
                    <ShareCard jobAdTitle={jobAdTitle} />
                </PopoverContent>
            </Popover>
        </div>
    );
}

export default ActionButtons;
